import React from 'react';
import styled from 'styled-components';

const FootDiv = styled.div`
    cursor: pointer;
    margin-bottom: 10px !important;
    &:last-child {
        margin-bottom: 30px !important;
    }
    @media screen and (min-width: 769px) {
        margin-bottom: 30px !important;
    }
    .info {
        border: 2px solid #fff;
        min-height: 120px;
        padding: 10px;
        text-align: center;
        @media screen and (min-width: 769px) {
            min-height: 200px;
            padding: 20px;
        }
        > img {
            max-width: 70%;
            @media screen and (min-width: 769px) and (max-width: 992px) {
                max-width: 100%;
            }
        }
        > * {
            margin: 0 auto;
            display: block;
            font-size: 70%;
            @media screen and (min-width: 769px) and (max-width: 992px) {
                font-size: 83%;
            }
            @media screen and (min-width: 993px) and (max-width: 1200px) {
                font-size: 85%;
            }
            @media screen and (min-width: 1201) {
                font-size: 100%;
            }
        }
        &.active {
          border: 2px solid #AEC90A;
        }
    }
`;

type FoodProps = {
    alt: string;
    src: string;
    caption: string;
    active: string;
    onClick: (clickedFood: string) => void;
}

export function Food(props: FoodProps) {
    return <FootDiv className={"ppi_column_container ppi_col-xs-6 ppi_col-md-3"}>
        <div className={props.active === props.alt ? 'info active' : 'info'} onClick={() => props.onClick(props.alt)}>
            <img src={props.src} alt={props.alt} />
            <strong>{props.alt}</strong>
            <span>{props.caption}</span>
        </div>
    </FootDiv>
}
